import { makeStyles } from '@mui/styles';

export const useMobileCardBaseStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0),
    borderRadius: theme.spacing(1),
  },
  amountSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    '& > .MuiFormControl-root': {
      flex: '0 0 50%',
      minWidth: 0,
    },
  },
  amountLabel: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    flex: '0 0 50%',
  },
  detailsSection: {
    marginTop: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(1),
  },
  detailRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: `${theme.spacing(0.5)} 0`,
    '& > .MuiFormControl-root': {
      flex: '0 0 50%',
      minWidth: 0,
    },
  },
  detailLabel: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    flex: '0 0 50%',
    minWidth: 0,
  },
  detailAmountWithAction: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.spacing(0.5),
    flex: '0 0 50%',
    minWidth: 0,
    '& > .MuiFormControl-root': {
      flex: '0 0 auto',
      width: '100%',
      minWidth: 0,
    },
  },
  payerAction: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  actionsBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(0.5),
  },
  toggleBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: `${theme.spacing(0.5)} 0`,
    color: theme.palette.secondary.main,
    fontFamily: 'inherit',
  },
  iconButton: {
    minWidth: 44,
    minHeight: 44,
  },
}));
